export const PERIMETER_FILTERS = [
    'activityTypesFilters',
    'storesFilters',
    'storesRegionFilters',
    'assortmentTypologyFilters',
    'productTypologyFilters',
    'businessBrandFilters',
    'consostyleMicroFilters',
    'lifestageMicroFilters',
    'integratedFranchisedFilters',
    'nomenclatureFilters',
    'triptyqueFilters',
    'suppliersFilters',
    'brandsFilters',
    'itemFilters',
    'barcodeFilters',
    'competitorBaseBarcodeFilters',
    'competitorBaseItemFilters',
    'competitorComparisonBarcodeFilters',
    'competitorComparisonItemFilters',
    'competitorBrandsFilters',
    'bemHoldingFilters',
    'bemMerchandiseFilters',
    'competitorFilters'
];
export const NIELSEN_UNAVAILABLE_PERIMETER_FILTERS = [
    'storesFilters',
    'storesRegionFilters',
    'activityTypesFilters',
    'assortmentTypologyFilters',
    'productTypologyFilters',
    'businessBrandFilters'
];
// Order matter
export const DEFAULT_PERIMETER_FILTERS = [
    {
        countries: 'default',
        filters: [
            'activityTypesFilters',
            'storesFilters',
            'storesRegionFilters',
            'businessBrandFilters',
            'integratedFranchisedFilters',
            'nomenclatureFilters',
            'triptyqueFilters',
            'brandsFilters',
            'competitorBrandsFilters',
            'competitorFilters'
        ]
    },
    { countries: ['BEL'], filters: ['bemMerchandiseFilters', 'barcodeFilters'] },
    { countries: ['FRA'], filters: ['suppliersFilters', 'bemHoldingFilters', 'barcodeFilters'] },
    { countries: ['ESP'], filters: ['suppliersFilters', 'bemHoldingFilters', 'itemFilters'] }
];
export const PERIMETER_FILTER_VIEW = [
    'possessionZoomPage',
    'possessionZoomPageWithTheoretical',
    'onboardingNomenclature',
    'onboardingStoresRegion',
    'competitorVisionZoomPage',
    'customerSegmentationPage'
];
const PERIMETER_FILTERS_PER_VIEW = {
    onboardingNomenclature: [{ countries: 'default', filters: ['nomenclatureFilters'] }],
    onboardingStoresRegion: [{ countries: 'default', filters: ['storesRegionFilters'] }],
    possessionZoomPage: [
        {
            countries: 'default',
            filters: [
                'activityTypesFilters',
                'storesFilters',
                'storesRegionFilters',
                'assortmentTypologyFilters',
                'productTypologyFilters',
                'integratedFranchisedFilters',
                'nomenclatureFilters',
                'triptyqueFilters',
                'brandsFilters'
            ]
        },
        {
            countries: ['FRA'],
            filters: ['suppliersFilters', 'bemHoldingFilters', 'barcodeFilters']
        },
        {
            countries: ['ESP'],
            filters: ['suppliersFilters', 'bemHoldingFilters', 'itemFilters']
        },
        {
            countries: ['BEL'],
            filters: ['bemMerchandiseFilters', 'barcodeFilters']
        }
    ],
    possessionZoomPageWithTheoretical: [
        {
            countries: 'default',
            filters: [
                'activityTypesFilters',
                'storesFilters',
                'storesRegionFilters',
                'assortmentTypologyFilters',
                'productTypologyFilters',
                'integratedFranchisedFilters',
                'nomenclatureFilters',
                'triptyqueFilters',
                'brandsFilters'
            ]
        },
        {
            countries: ['FRA'],
            filters: ['suppliersFilters', 'bemHoldingFilters', 'barcodeFilters']
        },
        {
            countries: ['ESP'],
            filters: ['suppliersFilters', 'bemHoldingFilters', 'itemFilters']
        },
        {
            countries: ['BEL'],
            filters: ['bemMerchandiseFilters', 'barcodeFilters']
        }
    ],
    competitorVisionZoomPage: [
        {
            countries: 'default',
            filters: [
                'activityTypesFilters',
                'storesFilters',
                'storesRegionFilters',
                'integratedFranchisedFilters',
                'nomenclatureFilters',
                'triptyqueFilters',
                'businessBrandFilters',
                'brandsFilters',
                'competitorBrandsFilters',
                'competitorFilters'
            ]
        },
        {
            countries: ['BEL'],
            filters: ['bemMerchandiseFilters', 'competitorBaseBarcodeFilters']
        },
        {
            countries: ['FRA'],
            filters: ['suppliersFilters', 'competitorBaseBarcodeFilters']
        },
        {
            countries: ['ESP'],
            filters: ['bemHoldingFilters', 'competitorBaseItemFilters']
        }
    ],
    customerSegmentationPage: [
        {
            countries: 'default',
            filters: [
                'activityTypesFilters',
                'storesFilters',
                'storesRegionFilters',
                'integratedFranchisedFilters',
                'nomenclatureFilters',
                'triptyqueFilters',
                'businessBrandFilters',
                'consostyleMicroFilters',
                'lifestageMicroFilters',
                'brandsFilters'
            ]
        },
        {
            countries: ['ESP'],
            filters: ['suppliersFilters', 'bemHoldingFilters', 'itemFilters']
        },
        {
            countries: ['FRA'],
            filters: ['suppliersFilters', 'bemHoldingFilters', 'barcodeFilters']
        },
        {
            countries: ['BEL'],
            filters: ['bemMerchandiseFilters', 'barcodeFilters']
        }
    ]
};
function mergeFiltersForCountry(rules, country) {
    const defaultFilters = rules.find((rule) => rule.countries === 'default')?.filters ?? [];
    const countrySpecificFilters = rules
        .filter((rule) => rule.countries !== 'default' && rule.countries.includes(country))
        .flatMap((rule) => rule.filters);
    return [...new Set([...defaultFilters, ...countrySpecificFilters])];
}
function sortByPerimeterFiltersOrder(filters) {
    return [...filters].sort((a, b) => PERIMETER_FILTERS.indexOf(a) - PERIMETER_FILTERS.indexOf(b));
}
export function getPerimeterFilters(view, country) {
    const rules = view ? PERIMETER_FILTERS_PER_VIEW[view] : undefined;
    const filters = rules
        ? mergeFiltersForCountry(rules, country)
        : mergeFiltersForCountry(DEFAULT_PERIMETER_FILTERS, country);
    return sortByPerimeterFiltersOrder(filters);
}
export const PERIMETER_FILTERS_TO_ONE_OF_REQUIREMENTS = {
    nomenclatureFilters: [{ name: 'productHierarchy', label: 'filterPopin.productNomenclature' }],
    storesFilters: [
        { name: 'chainType', label: 'filterPopin.chainType' },
        { name: 'stores', label: 'filterPopin.store' }
    ],
    activityTypesFilters: [{ name: 'activityType', label: 'filterPopin.activityType' }],
    businessBrandFilters: [{ name: 'businessBrand', label: 'filterPopin.businessBrand' }],
    integratedFranchisedFilters: [{ name: 'storeType', label: 'filterPopin.integrateFranchised' }],
    triptyqueFilters: [{ name: 'brandType', label: 'filterPopin.brandType' }],
    suppliersFilters: [
        { name: 'localSupplier', label: 'filterPopin.localSupplier' },
        { name: 'subSupplier', label: 'filterPopin.subSupplier' }
    ],
    brandsFilters: [{ name: 'brand', label: 'filterPopin.brand' }],
    bemHoldingFilters: [{ name: 'holding', label: 'filterPopin.holding' }],
    bemMerchandiseFilters: [{ name: 'holding', label: 'filterPopin.merchandise' }],
    barcodeFilters: [{ name: 'ean', label: 'filterPopin.ean' }],
    competitorBaseBarcodeFilters: [{ name: 'ean', label: 'filterPopin.ean' }],
    competitorBaseItemFilters: [{ name: 'ean', label: 'filterPopin.item' }],
    competitorComparisonBarcodeFilters: [{ name: 'ean', label: 'filterPopin.ean' }],
    competitorComparisonItemFilters: [{ name: 'ean', label: 'filterPopin.item' }],
    competitorBrandsFilters: [{ name: 'brand', label: 'filterPopin.competitorBrand' }],
    itemFilters: [{ name: 'ean', label: 'filterPopin.item' }],
    storesRegionFilters: [{ name: 'region', label: 'filterPopin.region' }],
    assortmentTypologyFilters: [{ name: 'assortmentTypology', label: 'filterPopin.assortmentTypology' }],
    productTypologyFilters: [{ name: 'productTypology', label: 'filterPopin.productTypology' }],
    competitorFilters: [{ name: 'competitorVision', label: 'filterPopin.competitors' }],
    consostyleMicroFilters: [{ name: 'customerSegmentation', label: 'filterPopin.consostyleMicro' }],
    lifestageMicroFilters: [{ name: 'customerSegmentation', label: 'filterPopin.lifestageMicro' }]
};
export const FILTERS_OR = {
    store: ['store_key', 'store_chain_type_key', 'chain_type'],
    product: ['sector_key', 'department_key', 'grp_class_key', 'class_key', 'sub_class_key'],
    competitorBrand: ['brand_desc_anonymized', 'brand_key_anonymized']
};
export const CUSTOMER_SEGMENTATION_TYPES = {
    CONSOSTYLE: 'consostyle',
    LIFESTAGE: 'lifestage'
};
export const CUSTOMER_SEGMENTATION_GRANULARITY_VIEWS = {
    MACRO: 'macro',
    MICRO: 'micro'
};
export const CUSTOMER_SEGMENTATION_SECTIONS = {
    UVC: 'UVC',
    CA: 'CA',
    CARDHOLDERS: 'CARDHOLDERS'
};
/**
 * Pages served by the `/detail/:name` route. The router derives its own union from this list,
 * so a page is declared once for the whole stack.
 */
export const DETAIL_VIEWS = [
    'sales-amount',
    'sales-quantity',
    'market-share',
    'possession-rate',
    'dn-dv',
    'dynamic-client'
];
/** Pages owning their own path, outside of `/detail/:name`. */
export const STANDALONE_VIEWS = [
    'performance',
    'business-equation',
    'customer-segmentation',
    'competitor-vision'
];
/**
 * Views (pages) a dynamic FilterDefinition can be restricted to — see the Page / FilterDefinitionPage tables.
 * Values are the vue-router route names, so a page keeps a single identity across the stack.
 * A FilterDefinition with no FilterDefinitionPage row is available on every view.
 *
 * Named `view` rather than `page` because `page` is already the pagination parameter of
 * GET /filter-definitions.
 */
export const FILTER_DEFINITION_VIEWS = [...DETAIL_VIEWS, ...STANDALONE_VIEWS];
/** Reference the right-hand chart compares against: the N+1 market, or Carrefour as a whole. */
export const BENCHMARK_MODE = {
    MARKET: 'market',
    CARREFOUR: 'carrefour'
};
//# sourceMappingURL=filters.model.js.map